module.exports = {
          srcSet: __webpack_public_path__ + "61d00cd9643fbd50a841b46155a26c61-984.png"+" 984w",
          images:[ {path: __webpack_public_path__ + "61d00cd9643fbd50a841b46155a26c61-984.png",width: 984,height: 600}],
          src: __webpack_public_path__ + "61d00cd9643fbd50a841b46155a26c61-984.png",
          toString:function(){return __webpack_public_path__ + "61d00cd9643fbd50a841b46155a26c61-984.png"},
          
          width: 984,
          height: 600
        }